import { render, staticRenderFns } from "./studyCommentSection.vue?vue&type=template&id=72a2da74&"
import script from "./studyCommentSection.vue?vue&type=script&lang=js&"
export * from "./studyCommentSection.vue?vue&type=script&lang=js&"
import style0 from "./studyCommentSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports